import {Header} from '@/components/commons/header/Header'
import {Divider} from '@/components/ui/divider/Divider'
import {PageBody, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {Outlet} from 'react-router-dom'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {usePermissions} from '@/features/auth/store/store'

export const UsersRoute = () => {
    const permissions = usePermissions()

    if (!permissions?.users?.read) {
        return <NoPermissionBox />
    }

    return (
        <PageBody>
            <Header />
            <Divider direction="horizontal" />
            <PageContent>
                <Outlet />
            </PageContent>
        </PageBody>
    )
}
